// 显示头部
export const SHOW_HEADER = 'SHOW_HEADER';
// 隐藏头部
export const HIDE_HEADER = 'HIDE_HEADER';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS';
export const CLEAR_USER_DATA = 'CLEAR_USER_DATA';


// WEBPACK FOOTER //
// ./src/store/mutation-types.js